import React from 'react'
import './Career_Card.css'
import { useLocation, useNavigate } from 'react-router-dom';
import { encodeId } from '../../../utils/common';

const Career_Card = ({ id, index, label, descn, image }) => {

    const location = useLocation();
    const navigate = useNavigate();

    const isCareerInner = location.pathname === `/career-inner/${id}`;

    const handleClick = () => {
        if (isCareerInner) {
            navigate('/career');
        } else {
            navigate(`/career-inner/${id}`);
        }
    };

    return (
        <div className='Career_Card'>
            <div className='top_div'>
                <div className='left_side'>
                    {index + 1 && (<p className='index'>{index + 1}</p>)}
                    <p className='title'>{label}</p>
                </div>
                <p className='view_text' onClick={handleClick}>
                    {isCareerInner ? 'View Less' : 'View'}
                </p>
            </div>

            <div className='descn_div'>
                <img src={image ? process.env.REACT_APP_IMG_URL + image : '/assets/images/career/banner/point.png'} className='point_img' />
                <p className='descn_text'>{descn}</p>
            </div>

        </div>
    )
}

export default Career_Card
